import { render } from "./HTML.vue?vue&type=template&id=23dd9ac2&scoped=true"
import script from "./HTML.vue?vue&type=script&lang=js"
export * from "./HTML.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-23dd9ac2"

export default script